import React from 'react';
import styled from 'styled-components/macro';
import { faSortDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type TabItem = {
  image: string;
  title: string;
  value: string;
};

type Props = {
  className?: string;
  tabs: TabItem[];
  toggleTab: (value: string) => void;
  activeTab: string;
};

export const Tabs = (props: Props) => {
  const { className = '', tabs, toggleTab, activeTab } = props;

  const renderedTabs = tabs.map((tab) => (
    <TabItemLi
      key={tab.title}
      className={`${activeTab === tab.value ? 'active' : ''}`}
      onClick={() => {
        toggleTab(tab.value);
      }}
    >
      <BgHelper />
      <TabTitle>
        {tab.title}
        {activeTab === tab.title && <ActiveCaret icon={faSortDown} />}
      </TabTitle>
      <TabOverlay />
      <TabBackground style={{ backgroundImage: `url(${tab.image})` }} />
    </TabItemLi>
  ));

  return (
    <TabsWrap className={`${className} tabs-wrap`}>
      <TabsList>{renderedTabs}</TabsList>
    </TabsWrap>
  );
};

const TabsWrap = styled.div`
  max-width: 2130px;
  margin: 0 auto;
  padding: 0 15px 0;
`;

const TabsList = styled.ul`
  width: 100%;
  margin: 20px 0;
  padding-left: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const BgHelper = styled.div`
  padding-top: 40%;
`;

const TabOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  display: inline-block;
  background: #000;
  opacity: 0.5;
  transition: opacity 0.75s ease;
  z-index: 1;
`;

const TabBackground = styled.div`
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const TabTitle = styled.span`
  font-size: 2.6rem;
  color: #fff;
  text-transform: uppercase;
  position: absolute;
  top: 40%;
  display: inline-block;
  width: 100%;
  text-align: center;
  text-shadow: none;
  z-index: 1;

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`;

const ActiveCaret = styled(FontAwesomeIcon)`
  text-shadow: none;
  line-height: 10px;
  display: block;
  width: 100%;
  margin-top: -0.35em;
`;

const TabItemLi = styled.li`
  position: relative;
  display: flex;
  float: left;
  width: 33%;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
  }

  &.active {
    ${TabBackground} {
      outline: 2px solid ${(props) => props.theme.primaryBtn1Bg};
      outline-offset: -2px;
    }
  }

  &:hover,
  &.active {
    ${TabOverlay} {
      opacity: 0;
    }
    ${TabTitle} {
      text-shadow: 1px 2px 1px #000;
    }
    ${ActiveCaret} {
      filter: drop-shadow(1px 2px 1px #000);
    }
  }
`;
